<template>
  <div class="container">
    <center>
    <br />
    <h1>Logged Out</h1><br />
    Thanks for using the system.<br />
    <br />
    To log back in, <a @click="login">click here</a>
  </center>
  </div>
</template>

<script>

export default {
  methods: {
    login: function () {
      location.reload()
      this.$router.push('/login')
    }
  },

  mounted () {

    this.logout()
  }
}

</script>



// WEBPACK FOOTER //
// Logout.vue?afaafad2